<template>
  <div id="small-screen">
    <div class="row">
      <div class="col-sm-12">
        <div class="modal-search text-center">
          <button class="btn btn-primary" style="margin-right: 350px" @click="setOpen(true)">
            Smart Search
          </button>

          <!-- The Modal -->
          <div class="modal fade" id="myModal">
            <ion-modal id="searchModal" :is-open="isOpen">
              <ion-header>
                <ion-toolbar>
                  <ion-button class="btn" fill="clear" slot="start" @click="setOpen(false)">
                    Confirm
                  </ion-button>
                  <ion-button class="btn" fill="clear" @click="setOpen(false)" slot="end">
                    X
                  </ion-button>
                </ion-toolbar>
              </ion-header>

              <ion-content>
                <div id="search">
                  <div class="dropdown-search">
                    <div class="container mt-3">
                      <div class="row">
                        <div class="col-12">
                          <auto-complete :page=page :initial-value="autocompleteSearchValue"
                                         :show-reset="Boolean($route.query.name)"
                                         @clicked="loadAutoCompleteSearch"
                                         @reset="resetAutoCompleteSearch"></auto-complete>
                        </div>
                        <div class="col-12 text-center mb-3" id="tagline">
                          <p>Easy to find... Simple to use</p>
                        </div>
                      </div>
                      <div class="row international-above-pick">
                        <div class="col-12 col-md-3">
                          <label class="country-heading">Country</label>
                        </div>
                        <div class="col-12 col-md-9">
                          <select name="" class="custom-select mb-3" v-model="selectedCountry" @change="changeState()">
                            <option selected>Select Country</option>
                            <option v-for="country in selectableCountries" :key="country.id"
                                    v-bind:value="{id: country.id, text: country.name}">{{ country.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-md-3">
                          <label class="location-heading">PICK</label>
                        </div>
                        <div class="col-12 col-md-9">
                          <select name="" class="custom-select mb-3" v-model="selectedState" @change="changeRegion()">
                            <option :value="0">Select State</option>
                            <option v-for="state in states" :key="state.id"
                                    v-bind:value="{id: state.id, text: state.name}">{{ displayStateName(state.name) }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 col-md-3">
                          <label class="location-heading">CHOOSE</label>
                        </div>
                        <div class="col-12 col-md-9">
                          <select name="" class="custom-select mb-3" v-model="selectedRegion" @change="changeTowns">
                            <option :value="0">Select Region</option>
                            <option v-for="region in regions" :key="region.id"
                                    v-bind:value="{id: region.id, text: region.name}">{{ region.name }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 col-md-3">
                          <label class="location-heading">MATCH</label>
                        </div>
                        <div class="col-12 col-md-9">
                          <select name="" class="custom-select mb-3" v-model="selectedTown" @change="selectTown">
                            <option :value="0">All Towns</option>
                            <option v-for="town in towns" :key="town.id"
                                    v-bind:value="{id: town.id, text: town.name, shire:town.shire}">{{ town.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div v-if="page=='smartcard'" class="row mt-5">
                        <div class="col-md-5">
                          <label>CREATE ITINERARY</label>
                        </div>
                        <div class="col-md-7 mt-n3">
                        <a class="button" style="background-color: #0d6efd;margin-left: -37%; font-size: 15px; border-radius: 6px; width: 30%;" :href="itenaryRoute">
                           <i class="fa fa-map-marker" aria-hidden="true"></i>...<i class="fa fa-map-marker" aria-hidden="true"></i>
                        </a>
                          <ion-badge v-model="itenaryLength" class="dot" style="margin: 0px -20px 10px;background-color: #0d6efd;">{{itenaryCount}}</ion-badge>
                        </div>
                      </div>
                      <div class="row" id="verticals">
                        <div class="col-12 filter-reset-row">
                          <p class="filter-reset-row__title">Verticals</p>
                          <button type="button" class="filter-reset-btn" @click="resetVerticalSearch">Reset</button>
                        </div>
                        <div class="col-md-12">
                          <input type="checkbox" value="1" v-model="verticals"><label for="eat">Eat</label> <br>
                          <input type="checkbox" value="2" v-model="verticals"><label for="sleep">Sleep</label> <br>
                          <input type="checkbox" value="3" v-model="verticals"><label for="see">See</label> <br>
                          <input type="checkbox" value="4" v-model="verticals"><label for="do">Do</label> <br>
                        </div>

                      </div>

                      <div class="row" id="verticals">
                        <div class="col-12 filter-reset-row">
                          <p class="filter-reset-row__title">Categories</p>
                          <button type="button" class="filter-reset-btn" @click="resetCategorySearch">Reset</button>
                        </div>
                        <div class="col-md-12" v-for="category in categories" :key="category.id">
                          <input type="checkbox" :value="category.id" v-model="selectedCategories"><label>{{category.name}}</label> <br>
                        </div>

                      </div>

                      <div class="row search-subcategory-row">
                        <div class="col-md-12" id="sub-category">
                          <label>Subcategories</label>
                        </div>
                        <div class="col-md-12 subcategory-control">
                          <select name="" class="custom-select" v-model="selectedSubCategory">
                            <option selected disabled :value="0" >Select Subcategory</option>
                            <option :value="-1">All</option>
                            <option v-for="subCategory in subCategories" :key="subCategory.id" :value="subCategory.id">{{subCategory.name}}</option>
                          </select>
                          <button type="button" class="filter-reset-btn subcategory-reset-btn"
                                  :disabled="selectedSubCategory === '0' || selectedSubCategory === 0"
                                  @click="resetSubCategorySearch">Reset</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ion-content>
            </ion-modal>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="col-xl-3" id="search-large" style="margin-top:10px!important;">

    <div class="dropdown-search">
      <div class="container mt-3">

        <form action="">
          <div class="row">
            <div class="col-12">
              <auto-complete :page=page :initial-value="autocompleteSearchValue"
                             :show-reset="Boolean($route.query.name)"
                             @clicked="loadAutoCompleteSearch"
                             @reset="resetAutoCompleteSearch"></auto-complete>
            </div>
            <div class="col-12 text-center mb-3" id="tagline">
              <p>Easy to find... Simple to use</p>
            </div>
          </div>
          <div class="row international-above-pick">
            <div class="col-12 col-md-3">
              <label class="country-heading">Country</label>
            </div>
            <div class="col-12 col-md-9">
              <select name="" class="custom-select mb-3" v-model="selectedCountry" @change="changeState()">
                <option selected>Select Country</option>
                <option v-for="country in selectableCountries" :key="country.id"
                        v-bind:value="{id: country.id, text: country.name}">{{ country.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-3">
              <label class="location-heading">PICK</label>
            </div>
            <div class="col-12 col-md-9">
              <select name="" class="custom-select mb-3" v-model="selectedState" @change="changeRegion()">
                <option :value="0">Select State</option>
                <option v-for="state in states" :key="state.id"
                        v-bind:value="{id: state.id, text: state.name}">{{ displayStateName(state.name) }}
                </option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-md-3">
              <label class="location-heading">CHOOSE</label>
            </div>
            <div class="col-12 col-md-9">
              <select name="" class="custom-select mb-3" v-model="selectedRegion" @change="changeTowns">
                <option :value="0">Select Region</option>
                <option v-for="region in regions" :key="region.id"
                        v-bind:value="{id: region.id, text: region.name}">{{ region.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-md-3">
              <label class="location-heading">MATCH</label>
            </div>
            <div class="col-12 col-md-9">
              <select name="" class="custom-select mb-3" v-model="selectedTown" @change="selectTown">
                <option :value="0">All Towns</option>
                <option v-for="town in towns" :key="town.id"
                        v-bind:value="{id: town.id, text: town.name, shire:town.shire}">{{ town.name }}
                </option>
              </select>
            </div>
          </div>
          <div v-if="page=='smartcard'" class="row mt-5">
            <div class="col-md-5">
              <label>CREATE ITINERARY</label>
            </div>
            <div class="col-md-7 mt-n3">
            <a class="button" style="background-color: #0d6efd;margin-left: -37%; font-size: 15px; border-radius: 6px; width: 30%;" :href="itenaryRoute">
               <i class="fa fa-map-marker" aria-hidden="true"></i>...<i class="fa fa-map-marker" aria-hidden="true"></i>
            </a>
              <ion-badge v-model="itenaryLength" class="dot" style="margin: 0px -20px 10px;background-color: #0d6efd;">{{itenaryCount}}</ion-badge>
            </div>
          </div>
          <div class="row" id="verticals">
            <div class="col-12 filter-reset-row">
              <p class="filter-reset-row__title">Verticals</p>
              <button type="button" class="filter-reset-btn" @click="resetVerticalSearch">Reset</button>
            </div>
            <div class="col-md-12">
              <input type="checkbox" value="1" v-model="verticals"><label for="eat">Eat</label> <br>
              <input type="checkbox" value="2" v-model="verticals"><label for="sleep">Sleep</label> <br>
              <input type="checkbox" value="3" v-model="verticals"><label for="see">See</label> <br>
              <input type="checkbox" value="4" v-model="verticals"><label for="do">Do</label> <br>
            </div>

          </div>

          <div class="row" id="verticals">
            <div class="col-12 filter-reset-row">
              <p class="filter-reset-row__title">Categories</p>
              <button type="button" class="filter-reset-btn" @click="resetCategorySearch">Reset</button>
            </div>
            <div class="col-md-12" v-for="category in categories" :key="category.id">
              <input type="checkbox" :value="category.id" v-model="selectedCategories"><label>{{category.name}}</label> <br>
            </div>

          </div>

          <div class="row search-subcategory-row">
            <div class="col-md-12" id="sub-category">
              <label>Subcategories</label>
            </div>
            <div class="col-md-12 subcategory-control">
              <select name="" class="custom-select" v-model="selectedSubCategory">
                <option selected disabled :value="0" >Select Subcategory</option>
                <option :value="-1">All</option>
                <option v-for="subCategory in subCategories" :key="subCategory.id" :value="subCategory.id">{{subCategory.name}}</option>
              </select>
              <button type="button" class="filter-reset-btn subcategory-reset-btn"
                      :disabled="selectedSubCategory === '0' || selectedSubCategory === 0"
                      @click="resetSubCategorySearch">Reset</button>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {mapGetters, mapActions} from "vuex";
import AutoComplete from "@/components/Autocomplete.vue";
import {IonModal} from "@ionic/vue";
import {IonContent} from "@ionic/vue";
import {IonToolbar} from "@ionic/vue";
import {IonButton} from "@ionic/vue";
import {IonHeader} from "@ionic/vue";
import {IonBadge} from "@ionic/vue";
import axios from "@/axios";
import { sortByName } from "@/utils/sortGeography";
import { displayStateName } from "@/utils/stateDisplayName";

function queryParamToString(value: unknown): string {
  if (value == null || value === '') return '';
  const raw = Array.isArray(value) ? value[value.length - 1] : value;
  const s = String(raw);
  try {
    return decodeURIComponent(s.replace(/\+/g, ' '));
  } catch {
    return s;
  }
}


export default defineComponent({
  name: 'smart-search',
  props: {
    page: String,
  },
  components: {AutoComplete, IonModal, IonContent, IonButton, IonToolbar, IonHeader, IonBadge},
  computed: {
    selectableCountries(): any[] {
      return (this.countries || []).filter((country: any) => {
        const countryName = (country?.name || '').trim().toLowerCase();
        return countryName !== 'new zealand' && countryName !== 'nz';
      });
    },
    ...mapGetters({
      getCountries: 'countries/getCountries',
      getStates: 'states/getStates',
      getRegions: 'regions/getRegions',
      getTowns: 'towns/getTowns',
      getItenary: 'itenary/getItenary'
    }),
    itenaryCount() {
      const itenary = this.getItenary;
      return itenary.length;
    }
  },
  watch: {
    '$route.fullPath': function(newPath) {
      if (!this.isInitialized) return;
      if (newPath === this.pendingRoutePath) {
        this.pendingRoutePath = '';
        return;
      }
      this.restoreRouteQuery(this.$route.query);
    },
    verticals: function(){
      if (!this.isInitialized || this.isSyncingRoute) return;
      this.setFilters({name: 'verticals', id: this.verticals.join(',')},'verticals')
      let verticalArr = this.verticals.map(value => parseInt(value));
      if(this.verticals.length > 0) {
        this.categories = this.sortedByName(this.allCategories.filter(item => verticalArr.indexOf(item['vertical_id']) !== -1));
      }
      else {
        this.categories = this.allCategories;
      }
      this.syncSubCategoriesList();
      this.updateRouteQuery();
      this.$emit('clicked', this.filters, this.currentBreadcrumbs());
    },
    selectedCategories: function(){
      if (!this.isInitialized || this.isSyncingRoute) return;
      this.setFilters({name: 'categories', id: this.selectedCategories.join(',')},'categories')
      this.syncSubCategoriesList();
      this.updateRouteQuery();
      this.$emit('clicked', this.filters, this.currentBreadcrumbs());
    },
    selectedSubCategory: function(){
      if (!this.isInitialized || this.isSyncingRoute) return;
      if(this.selectedSubCategory > 0) {
        this.setFilters({name: 'subCategory', id: this.selectedSubCategory}, 'subCategory')
        this.updateRouteQuery();
        this.$emit('clicked', this.filters, this.currentBreadcrumbs());
      } else {
        this.selectedSubCategory = '0'
        this.setFilters({name: 'subCategory'}, 'subCategory')
        this.updateRouteQuery();
        this.$emit('clicked', this.filters, this.currentBreadcrumbs());
      }
    }
  },
  async created() {
    this.selectedState = "0"
    this.selectedRegion = "0"
    this.selectedTown = "0"
    this.selectedSubCategory="0"
    const cachedCountries = JSON.parse(localStorage.getItem('countries') || '[]')
    const cachedStates = JSON.parse(localStorage.getItem('states') || 'null')
    const cachedRegions = JSON.parse(localStorage.getItem('regions') || '[]')
    const cachedTowns = JSON.parse(localStorage.getItem('towns') || '[]')
    this.countries = Array.isArray(cachedCountries) ? cachedCountries : []
    if (this.countries.length === 0) {
      await this.fetchCountries()
      this.countries = Array.isArray(this.getCountries) ? this.getCountries : []
    }
    this.states = sortByName(Array.isArray(cachedStates) ? cachedStates : [])
    this.regions = Array.isArray(cachedRegions) ? cachedRegions : []
    this.towns = sortByName(Array.isArray(cachedTowns) ? cachedTowns : [])
    
    // Restore country from query
    this.countries.forEach(country => {
      if (country['name'] === this.$route.query.country) {
        this.selectedCountry = {id: country['id'], text: country['name']}
        this.setFilters({name: 'country', id: this.selectedCountry['id']}, 'country');
      }
    });
    
    // Restore state from query
    if (this.$route.query.state) {
      await this.showStates();
      const qState = queryParamToString(this.$route.query.state);
      this.states.forEach(state => {
        if (state['name'] === qState || displayStateName(state['name']) === qState) {
          this.selectedState = {id: state['id'], text: state['name']}
          this.setFilters({name: 'state', id: this.selectedState['id']}, 'state');
        }
      });
    }
    
    // Restore region from query — must load towns here; @change on the region select only runs on user interaction
    if (this.$route.query.region) {
      await this.showRegions();
      const qRegion = queryParamToString(this.$route.query.region);
      const matchedRegion = Array.isArray(this.regions)
        ? this.regions.find(region => region['name'] === qRegion)
        : undefined;
      if (matchedRegion) {
        this.selectedRegion = {id: matchedRegion['id'], text: matchedRegion['name']};
        this.setFilters({name: 'region', id: this.selectedRegion['id']}, 'region');
        await this.showTowns();
      }
    }
    
    // Restore town from query
    if (this.$route.query.town) {
      await this.showTowns();
      this.towns.forEach(town => {
        if (town['name'] === this.$route.query.town) {
          this.selectedTown = {id: town['id'], text: town['name'], shire: town['shire'] || ''}
          this.setFilters({name: 'town', id: this.selectedTown['id']}, 'town');
        }
      });
    }
    
    // Restore autocomplete search name from query
    if (this.$route.query.name) {
      this.setFilters({name:'name', id: this.$route.query.name}, 'name');
      // Set the autocomplete input value (will be handled by the component)
      this.autocompleteSearchValue = this.$route.query.name;
    }
    
    // Restore verticals from query
    if (this.$route.query.verticals) {
      const verticalsArray = String(this.$route.query.verticals).split(',').filter(Boolean);
      this.verticals = verticalsArray.map(v => String(v));
      this.setFilters({name: 'verticals', id: this.verticals.join(',')}, 'verticals');
    }
    
    // Restore categories from query
    if (this.$route.query.categories) {
      const categoriesArray = String(this.$route.query.categories).split(',').filter(Boolean);
      this.selectedCategories = categoriesArray.map(c => String(c));
      this.setFilters({name: 'categories', id: this.selectedCategories.join(',')}, 'categories');
    }
    
    // Restore subcategory from query
    if (this.$route.query.subcategory) {
      this.selectedSubCategory = String(this.$route.query.subcategory);
    }
    
    await this.showCategories()
    await this.showSubCategories()
    if (this.verticals.length > 0) {
      const verticalArr = this.verticals.map(value => parseInt(String(value), 10));
      this.categories = this.sortedByName(this.allCategories.filter(item => verticalArr.indexOf(item['vertical_id']) !== -1));
    }
    this.syncSubCategoriesList();
    this.$emit('clicked', this.filters, this.currentBreadcrumbs());
    // Set initialized flag after all setup is complete to prevent watchers from firing during init
    this.$nextTick(() => {
      this.isInitialized = true;
    });
  },
  methods: {
    displayStateName,
    ...mapActions({
      fetchCountries: 'countries/fetchCountries',
      fetchStates: 'states/fetchStates',
      fetchRegions: 'regions/fetchRegions',
      fetchTowns: 'towns/fetchTowns'
    }),
    async loadAutoCompleteSearch(value) {
      const businessName = typeof value === 'object' && value.name ? value.name : value;

      if (!businessName) {
        if (this.$route.query.name) {
          await this.resetAutoCompleteSearch();
        }
        return;
      }

      if (!this.$route.query.name) {
        sessionStorage.setItem(
          this.previousSearchStorageKey(),
          JSON.stringify(this.currentSearchQuery())
        );
      }

      const location = typeof value === 'object' ? value.location : null;
      const query: any = {name: businessName};

      if (location?.country) {
        query.country = location.country.name;
      } else {
        query.country = this.selectedCountry?.['text'] || 'Australia';
      }
      if (location?.state) {
        query.state = displayStateName(location.state.name);
      }
      if (location?.region) {
        query.region = location.region.name;
      }
      if (location?.town) {
        query.town = location.town.name;
      }

      this.autocompleteSearchValue = businessName;
      await this.$router.push({
        path: this.$route.path,
        query: query
      });
    },
    previousSearchStorageKey() {
      return `fis:previous-search:${this.$route.path}`;
    },
    async resetAutoCompleteSearch() {
      let previousQuery: any = null;
      const storageKey = this.previousSearchStorageKey();

      try {
        const storedQuery = sessionStorage.getItem(storageKey);
        previousQuery = storedQuery ? JSON.parse(storedQuery) : null;
      } catch (error) {
        previousQuery = null;
      }

      if (!previousQuery) {
        previousQuery = {...this.$route.query};
        delete previousQuery.name;
      }

      await this.$router.replace({
        path: this.$route.path,
        query: previousQuery
      });
    },
    currentSearchQuery() {
      const query: any = {...this.$route.query};
      delete query.name;

      const setOrDelete = (key: string, value: any) => {
        if (value === undefined || value === null || value === '') {
          delete query[key];
        } else {
          query[key] = value;
        }
      };

      setOrDelete('country', this.selectedCountry?.['text']);
      setOrDelete(
        'state',
        this.selectedState?.['text']
          ? displayStateName(this.selectedState['text'])
          : null
      );
      setOrDelete(
        'region',
        this.selectedRegion?.['text']
          ? this.selectedRegion['text']
          : null
      );
      setOrDelete(
        'town',
        this.selectedTown?.['text']
          ? this.selectedTown['text']
          : null
      );
      setOrDelete('verticals', this.verticals?.length ? this.verticals.join(',') : null);
      setOrDelete('categories', this.selectedCategories?.length ? this.selectedCategories.join(',') : null);
      setOrDelete(
        'subcategory',
        this.selectedSubCategory && this.selectedSubCategory !== "0"
          ? this.selectedSubCategory
          : null
      );

      return query;
    },
    currentBreadcrumbs() {
      const breadcrumbs: Array<string> = [];
      const verticalNames = {
        '1': 'Eat',
        '2': 'Sleep',
        '3': 'See',
        '4': 'Do'
      };

      if (this.selectedCountry && this.selectedCountry['text']) {
        breadcrumbs.push(this.selectedCountry['text']);
      }
      if (this.selectedState && this.selectedState !== "0" && this.selectedState['text']) {
        breadcrumbs.push(displayStateName(this.selectedState['text']));
      }
      if (this.selectedRegion && this.selectedRegion !== "0" && this.selectedRegion['text']) {
        breadcrumbs.push(this.selectedRegion['text']);
      }
      if (this.selectedTown && this.selectedTown !== "0" && this.selectedTown['text']) {
        breadcrumbs.push(this.selectedTown['text']);
        if (this.selectedTown['shire']) {
          breadcrumbs.push(this.selectedTown['shire']);
        }
      } else {
        breadcrumbs.push('All Towns');
      }

      breadcrumbs.push(this.page === 'businesslist' ? 'Members Listing' : 'Members Display');

      this.verticals.forEach(verticalId => {
        const verticalName = verticalNames[String(verticalId)];
        if (verticalName) {
          breadcrumbs.push(verticalName);
        }
      });

      this.selectedCategories.forEach(categoryId => {
        const category = this.allCategories.find(item => Number(item.id) === Number(categoryId));
        if (category?.name) {
          breadcrumbs.push(category.name);
        }
      });

      if (this.selectedSubCategory && this.selectedSubCategory !== '0' && this.selectedSubCategory !== 0) {
        if (this.selectedSubCategory === '-1' || this.selectedSubCategory === -1) {
          breadcrumbs.push('All Subcategories');
        } else {
          const subCategory = this.allSubcategories.find(
            item => Number(item.id) === Number(this.selectedSubCategory)
          );
          if (subCategory?.name) {
            breadcrumbs.push(subCategory.name);
          }
        }
      }
      return breadcrumbs;
    },
    async restoreRouteQuery(query) {
      this.isSyncingRoute = true;
      try {
        const countryName = queryParamToString(query.country);
        const country = this.countries.find(item => item.name === countryName);
        this.selectedCountry = country ? {id: country.id, text: country.name} : {};

        this.states = [];
        this.selectedState = '0';
        if (country) {
          await this.showStates();
          const stateName = queryParamToString(query.state);
          const state = this.states.find(
            item => item.name === stateName || displayStateName(item.name) === stateName
          );
          if (state) this.selectedState = {id: state.id, text: state.name};
        }

        this.regions = [];
        this.selectedRegion = '0';
        if (this.selectedState !== '0') {
          await this.showRegions();
          const regionName = queryParamToString(query.region);
          const region = this.regions.find(item => item.name === regionName);
          if (region) this.selectedRegion = {id: region.id, text: region.name};
        }

        this.towns = [];
        this.selectedTown = '0';
        if (this.selectedRegion !== '0') {
          await this.showTowns();
          const townName = queryParamToString(query.town);
          const town = this.towns.find(item => item.name === townName);
          if (town) {
            this.selectedTown = {id: town.id, text: town.name, shire: town.shire || ''};
          }
        }

        this.verticals = query.verticals
          ? queryParamToString(query.verticals).split(',').filter(Boolean)
          : [];
        this.selectedCategories = query.categories
          ? queryParamToString(query.categories).split(',').filter(Boolean)
          : [];
        this.selectedSubCategory = query.subcategory
          ? queryParamToString(query.subcategory)
          : '0';
        this.autocompleteSearchValue = queryParamToString(query.name);

        const verticalIds = this.verticals.map(value => parseInt(String(value), 10));
        this.categories = verticalIds.length
          ? this.sortedByName(this.allCategories.filter(item => verticalIds.indexOf(Number(item.vertical_id)) !== -1))
          : this.allCategories;
        this.syncSubCategoriesList();

        this.filters = [];
        if (country) this.setFilters({name: 'country', id: country.id}, 'country');
        if (this.selectedState !== '0') this.setFilters({name: 'state', id: this.selectedState.id}, 'state');
        if (this.selectedRegion !== '0') this.setFilters({name: 'region', id: this.selectedRegion.id}, 'region');
        if (this.selectedTown !== '0') this.setFilters({name: 'town', id: this.selectedTown.id}, 'town');
        if (this.autocompleteSearchValue) {
          this.setFilters({name: 'name', id: this.autocompleteSearchValue}, 'name');
        }
        if (this.verticals.length) this.setFilters({name: 'verticals', id: this.verticals.join(',')}, 'verticals');
        if (this.selectedCategories.length) this.setFilters({name: 'categories', id: this.selectedCategories.join(',')}, 'categories');
        if (Number(this.selectedSubCategory) > 0) {
          this.setFilters({name: 'subCategory', id: this.selectedSubCategory}, 'subCategory');
        }
      } finally {
        this.isSyncingRoute = false;
      }

      this.$emit('clicked', this.filters, this.currentBreadcrumbs());
    },
    setFilters($value, $filterName) {
      let index = this.filters.findIndex(function (filter) {
        return filter.name == $filterName
      });
      if (index > -1) {
        this.filters.splice(index, this.filters.length - (index));
      }
      if (typeof ($value.id) !== "undefined") {
        this.filters.push($value)
      }
    },
    setOpen(isOpen: boolean) {
      this.isOpen = isOpen;
    },
    changeState() {
      this.selectedState = "0"
      this.selectedRegion = "0"
      this.selectedTown = "0"
      this.showStates();
      this.setFilters({name: 'country', id: this.selectedCountry['id']}, 'country');
      this.updateRouteQuery();
      this.$emit('clicked', this.filters, this.currentBreadcrumbs());
    },
    changeRegion() {
      this.selectedRegion = "0"
      this.selectedTown = "0"
      this.showRegions();
      this.setFilters({name: 'state', id: this.selectedState['id']}, 'state');
      this.updateRouteQuery();
      this.$emit('clicked', this.filters, this.currentBreadcrumbs());
    },
    changeTowns() {
      this.selectedTown = "0"
      this.showTowns();
      this.setFilters({name: 'region', id: this.selectedRegion['id']}, 'region');
      this.updateRouteQuery();
      this.$emit('clicked', this.filters, this.currentBreadcrumbs());
    },
    selectTown() {
      this.setFilters({name: 'town', id: this.selectedTown['id']}, 'town');
      this.updateRouteQuery();
      this.$emit('clicked', this.filters, this.currentBreadcrumbs());
    },
    resetVerticalSearch() {
      this.verticals = [];
      this.setFilters({name: 'verticals', id: this.verticals.join(',')},'verticals');
      this.updateRouteQuery();
      this.$emit('clicked', this.filters, this.currentBreadcrumbs());
    },
    resetCategorySearch() {
      this.selectedCategories = [];
    },
    resetSubCategorySearch() {
      if (this.selectedSubCategory === '0' || this.selectedSubCategory === 0) return;
      this.selectedSubCategory = '0';
    },
    /** Subcategories shown in the dropdown: all under visible categories, or only those under ticked categories when any are selected. */
    syncSubCategoriesList() {
      const visibleCategoryIds = this.categories.map(c => Number(c.id));
      let pool = this.allSubcategories.filter(
        sc => visibleCategoryIds.indexOf(Number(sc.category_id)) !== -1
      );
      if (this.selectedCategories && this.selectedCategories.length > 0) {
        const selectedIds = this.selectedCategories.map(id => parseInt(String(id), 10));
        pool = pool.filter(sc => selectedIds.indexOf(Number(sc.category_id)) !== -1);
      }
      this.subCategories = this.sortedByName(pool);

      const current = this.selectedSubCategory;
      if (current === undefined || current === null || current === '' || current === '0' || current === 0) {
        return;
      }
      if (current === -1 || current === '-1') {
        return;
      }
      const validIds = pool.map(s => Number(s.id));
      const curId = parseInt(String(current), 10);
      if (validIds.indexOf(curId) === -1) {
        this.selectedSubCategory = '0';
        this.setFilters({name: 'subCategory'}, 'subCategory');
        if (this.isInitialized) {
          this.updateRouteQuery();
          this.$emit('clicked', this.filters, this.currentBreadcrumbs());
        }
      }
    },
    updateRouteQuery() {
      const query: any = this.currentSearchQuery();
      if (this.$route.query.name) {
        query.name = this.$route.query.name;
      }

      const target = this.$router.resolve({
        path: this.$route.path,
        query: query
      });
      if (target.fullPath === this.$route.fullPath) return;
      this.pendingRoutePath = target.fullPath;
      this.$router.push(target).catch(() => {
        this.pendingRoutePath = '';
      });
    },
    async showStates() {
      await this.fetchStates(this.selectedCountry['id']);
      this.states = this.getStates;
    },
    async showRegions() {
      await this.fetchRegions(this.selectedState['id']);
      this.regions = this.getRegions;
    },
    async showTowns() {
      await this.fetchTowns(this.selectedRegion['id']);
      this.towns = sortByName(this.getTowns);
    },
    sortedByName(arr) {
      return [...arr].sort((a, b) => a.name.localeCompare(b.name));
    },
    async showCategories() {
      const response = await axios.get("/category");
      this.allCategories = this.sortedByName(response.data);
      this.categories = this.allCategories;
    },
    async showSubCategories() {
      const response = await axios.get("/sub-category");
      this.allSubcategories = this.sortedByName(response.data);
      this.subCategories = this.allSubcategories;
    }
  },
  data() {
    return {
      isOpen: false,
      isInitialized: false,
      isSyncingRoute: false,
      pendingRoutePath: '',
      filters: [] as Array<any>,
      countries: [],
      categories: [],
      subCategories: [],
      verticals: [] as Array<any>,
      states: [],
      regions: [],
      towns: [],
      selectedTown: {},
      selectedState: {},
      selectedRegion: {},
      selectedCountry: {},
      selectedCategories: [] as Array<any>,
      selectedSubCategory: {},
      allCategories: [],
      allSubcategories: [],
      itenaryRoute: "/smart-planner",
      autocompleteSearchValue: ''
    }
  }
});

</script>

<style scoped>
#tagline p {
  color: #34aade;
  font-weight: 600;
}

.international-above-pick {
  margin-top: 0.35rem;
}

ion-modal#searchModal {
  --border-radius: 6px;
  --box-shadow: 0 28px 48px rgba(0, 0, 0, 0.4);
}

ion-content {
  --offset-bottom: -15% !important;
}
.dot {
  height: 20px;
  width: 21px;
  border-radius: 50%;
  display: inline-block;
}

/* Filter labels: INTERNATIONAL, PICK, CHOOSE, MATCH, Eat/Sleep/See/Do, category names */
label {
  font-weight: 700;
}

.country-heading,
.location-heading {
  font-size: 0.9em !important;
}

/* Verticals / Category heading + Reset (matches #breadcrums p — app.css) */
.filter-reset-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 0.35rem 0.45rem;
  margin-bottom: 0.35rem;
}

.row#verticals .filter-reset-row > .filter-reset-row__title {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.filter-reset-row__title {
  font-size: 0.9em;
  font-weight: bold;
  text-align: left;
  flex: 0 0 auto;
  margin-right: 0;
}

.filter-reset-btn {
  flex: 0 0 auto;
  width: auto;
  min-width: unset;
  color: #fff;
  font-weight: 600;
  font-size: 0.75rem;
  background: #34aade;
  border: 1px solid #34aade;
  border-radius: 4px;
  padding: 0.15rem 0.45rem;
  line-height: 1.25;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.filter-reset-btn:hover,
.filter-reset-btn:focus-visible {
  color: #fff;
  background: #2b8ec8;
  border-color: #2b8ec8;
  outline: none;
}

.subcategory-control {
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

.subcategory-control .custom-select {
  min-width: 0;
  flex: 1 1 auto;
  width: auto;
}

.subcategory-reset-btn {
  align-self: stretch;
}

.subcategory-reset-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

</style>
